import { render } from "./EditList.vue?vue&type=template&id=0f28d087"
import script from "./EditList.vue?vue&type=script&lang=js"
export * from "./EditList.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__